// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__15cmH","dragIcon":"SortableItem_dragIcon__LRb5b","disabled":"SortableItem_disabled__2WTUA"};